import { useEffect, useRef, useState } from 'react';

/** Houdt bij of de browser offline is. `onBackOnline` wordt aangeroepen zodra de verbinding terugkomt. */
export function useOnlineStatus(onBackOnline?: () => void) {
  const [isOffline, setIsOffline] = useState(typeof navigator !== 'undefined' ? !navigator.onLine : false);
  const callback = useRef(onBackOnline);
  callback.current = onBackOnline;

  useEffect(() => {
    const handleOnline = () => {
      setIsOffline(false);
      callback.current?.();
    };
    const handleOffline = () => setIsOffline(true);

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);
    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);

  return isOffline;
}
